import React, {useContext} from 'react';
//import LoadingPageBody from './LoadingPageBody';
import {AutofillProgressBar, Loader} from '@activehub/common-components-spa';
import { AppContext } from 'src/App'

export const LoadingPageView = (props) => {
  const {translate} = useContext(AppContext);
  return (
    <div>
      <AutofillProgressBar {...props} />
      <Loader />
      {/* <LoadingPageBody t={translate} /> */}
    </div>
  );
};
